module.exports = __webpack_public_path__ + "zvetseni-prsou_32_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_32_before.jpg
// module id = 1326
// module chunks = 0